<template>
  <agent-default>
    <pa-sale-page channel="agent" />
  </agent-default>
</template>

<script>
import AgentDefault from '@/components/layout/AgentDefault';
import PaSalePage from '@/components/pa/PaSalePage';

export default {
  name: 'AgentPaSale',
  components: { AgentDefault, PaSalePage },
  metaInfo: { title: 'Students PA — Sale' },
};
</script>
